<template lang="pug">
.home
  back-slide-page
    router-view
  
</template>
<script>
import BackSlidePage from '@/components/layout/BackSlidePage'
export default {
  name: 'index',
  components: { BackSlidePage },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
